<div class="org-header">

    <div class="org-logo" *ngIf="showLogo">
        <myapp-image-asset style="width: 200px;" [imageAsset]="organization?.Logo" [width]="200" [height]="200" [usePlaceholder]="true" [useBorder]="false"></myapp-image-asset>
    </div>

    <div *ngIf="album != null">
        <div class="welcome-text" *ngIf="album.Id === 0">
            Welcome to our photo gallery. Select the album and then browse the photos and videos.
            You will have the option to download the photos free – our gift to you!
        </div>

        <div class="title-bar">
            <div class="left">Gallery{{album.Id !== 0 ? ' - Albums' : ''}} {{album.IsFolder ? '' : '- Photos'}}</div>
            <div *ngIf="album.Id !== 0" class="middle">{{album.Name}}</div>
            <div></div>
        </div>
    </div>
</div>
